



import Vue from "vue";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import GenAiDashboard from "./GenAiDashboard.vue";
import { state } from "./data/state";
import { enable_gen_ai_mocks, restore_gen_ai_mocks } from "./data/drilldown";

export default Vue.extend({
  components: { GenAiDashboard },
  setup() {
    // the gql mocks must stay active for as long as this source is on screen —
    // the events/content modals swap between each other and re-query each time
    onMounted(() => {
      enable_gen_ai_mocks();
      state.init();
    });

    onBeforeUnmount(restore_gen_ai_mocks);
    return {};
  },
});
